import { createContext } from "react";
const GalleryMultipageContext = createContext({});
export default GalleryMultipageContext;
